// @ts-nocheck
import {
    ApiHandlerDiscreteParameter,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    UpdateCartLineApiParameter,
    updateCartLineWithResult as updateCartLineApi,
} from "@insite/client-framework/Services/CartService";
import {
    chain,
    ExecuteOnSuccessCallback,
    UpdateCartLine,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

interface UpdateCartLineParameter {
    onSuccess?: (cartline?: CartLineModel) => void; // Store Custom Code
    cartLine: CartLineModel;
    shouldNotReloadPromotions?: boolean;
    shouldNotLoadFullCart?: boolean;
}

type HandlerType = ApiHandlerDiscreteParameter<UpdateCartLineParameter, UpdateCartLineApiParameter, CartLineModel>; // Store Custom Code

export const StoreUpdateCartLine: HandlerType = async props => {
    const result = await updateCartLineApi(props.apiParameter);
    /* Store Custom Code - Start */
    if (result.successful) {
        props.apiResult = result.result;
    }
    /* Store Custom Code - End */
};
replaceInChain(chain, UpdateCartLine, StoreUpdateCartLine);

export const StoreExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult); // Store Custom Code
};
replaceInChain(chain, ExecuteOnSuccessCallback, StoreExecuteOnSuccessCallback);
